import {
  MOVE_ITEMS, OFFICE_ITEMS, CLEARANCE_ITEMS, SIZES_MOVE, SIZES_CLEARANCE, BULKY, BULKY_CLEARANCE, isClearanceSvc, isOfficeSvc,
} from '../EstimateWizard.constants';

export const SERVICE_OPTIONS = [
  ['removal', 'House / flat removal'], ['office-move', 'Office / commercial move'], ['man-van', 'Man & Van'],
  ['delivery', 'Delivery / collection'], ['rubbish-clearance', 'Rubbish clearance'], ['house-clearance', 'House clearance'],
  ['garage-clearance', 'Garage clearance'], ['office-clearance', 'Office clearance'], ['other', 'Other'],
];
const SERVICE_LABEL = Object.fromEntries(SERVICE_OPTIONS);
export const serviceLabel = (s) => SERVICE_LABEL[s] || s;

export const ALL_ITEMS = [...MOVE_ITEMS, ...OFFICE_ITEMS, ...CLEARANCE_ITEMS];
const LABEL = Object.fromEntries(ALL_ITEMS.map(i => [i.id, i.label]));

export const EMPTY_INV = {
  property_size: '', item_counts: {}, boxes_small: 0, boxes_medium: 0, boxes_large: 0, extras: [],
  pickup_access: 'Ground floor', dropoff_access: 'Ground floor', waste_location: '', packing: false, dismantle: false,
};

export const jobKind = (service) => (isClearanceSvc(service) ? 'clearance' : isOfficeSvc(service) ? 'office' : 'move');

export const optionsFor = (service) => {
  const k = jobKind(service);
  return {
    kind: k,
    items: k === 'clearance' ? CLEARANCE_ITEMS : k === 'office' ? OFFICE_ITEMS : MOVE_ITEMS,
    sizes: k === 'clearance' ? SIZES_CLEARANCE : SIZES_MOVE,
    bulky: k === 'clearance' ? BULKY_CLEARANCE : BULKY,
  };
};

// Prefill from a saved office inventory, or rebuild one from the customer's online quote.
export const inventoryFromJob = (job) => {
  if (job.inventory) return { ...EMPTY_INV, ...job.inventory };
  const w = job.wizard_inventory || {};
  const inv = { ...EMPTY_INV, property_size: job.property_size || '', item_counts: {}, extras: [] };
  ['boxes_small', 'boxes_medium', 'boxes_large'].forEach(k => { inv[k] = parseInt(w[k], 10) || 0; });
  ['pickup_access', 'dropoff_access'].forEach(k => { inv[k] = w[k] || ''; });
  inv.packing = !!w.packing; inv.dismantle = !!w.dismantle;
  const byLabel = Object.fromEntries(optionsFor(job.service).items.map(i => [i.label, i.id]));
  (w.heavy_items || []).forEach((s) => {
    const m = String(s).match(/^(\d+) × (.+)$/);
    if (m && byLabel[m[2]]) inv.item_counts[byLabel[m[2]]] = parseInt(m[1], 10);
    else if (String(s).startsWith('Waste location: ')) inv.waste_location = s.slice(16);
    else if ([...BULKY, ...BULKY_CLEARANCE].includes(s)) inv.extras.push(s);
  });
  return inv;
};

export const inventoryLines = (inv) => {
  const boxes = (inv.boxes_small || 0) + (inv.boxes_medium || 0) + (inv.boxes_large || 0);
  return [
    ...Object.entries(inv.item_counts || {}).filter(([, q]) => q > 0).map(([id, q]) => `${q} × ${LABEL[id] || id}`),
    boxes ? `${boxes} boxes (${inv.boxes_small || 0} small, ${inv.boxes_medium || 0} medium, ${inv.boxes_large || 0} large)` : null,
    ...(inv.extras || []),
  ].filter(Boolean);
};

export const inventoryFacts = (inv, service) => {
  const clearance = jobKind(service) === 'clearance';
  return [
    inv.property_size,
    clearance ? (inv.waste_location && `Waste: ${inv.waste_location}`) : null,
    inv.pickup_access && `${clearance ? 'Access' : 'Pickup'}: ${inv.pickup_access}`,
    !clearance && inv.dropoff_access ? `Drop-off: ${inv.dropoff_access}` : null,
    inv.packing && 'Packing service',
    inv.dismantle && 'Dismantle / reassemble',
  ].filter(Boolean);
};
